module.exports = __webpack_public_path__ + "static/logo-6f7260153aa66b8dfdac934f5d58bba9.svg";